// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"6660f814b43eb7b1c865","293":"41de27cc8fc5bffe8b42","518":"7a58d6d4cebf33b48dc3","779":"46e469dc37da4298c4ce"}[chunkId] + ".js";
};